import Vue from 'vue'
import Resource from 'vue-resource'
import store from '@/store'
Vue.use(Resource)

export default {
	findAll (params = {}, fullResponse = false) {
		return new Promise(function (resolve, reject) {
			Vue.http.get(store.state.apiURL + '/v1/users', {
				params: params
			}).then(function (response) {
				if (fullResponse === true) {
					resolve(response)
				} else {
					resolve(response.body)
				}
			}, function (response) {
				reject(response)
			})
		})
	},
	findOne (id, params = {}) {
		return new Promise(function (resolve, reject) {
			Vue.http.get(store.state.apiURL + '/v1/users/' + id + '?' + new Date().getTime(), {
				params: params
			}).then(function (response) {
				resolve(response.body)
			}, function (response) {
				reject(response)
			})
		})
	},
	create (params = {}) {
		return new Promise(function (resolve, reject) {
			Vue.http.post(store.state.apiURL + '/v1/users', params).then(function (response) {
				resolve(response.body)
			}, function (response) {
				reject(response.body)
			})
		})
	},
	update (id, params = {}) {
		return new Promise(function (resolve, reject) {
			Vue.http.put(store.state.apiURL + '/v1/users/' + id, params).then(function (response) {
				resolve(response.body)
			}, function (response) {
				reject(response.body)
			})
		})
	}
}



// WEBPACK FOOTER //
// ./src/api/modules/user/user.js